"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newDashboardMetadataObject = exports.DashboardMetadataObjectBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var factory_1 = require("./factory");
var builder_1 = require("../builder");
/**
 * Dashboard metadata object builder
 * See {@link Builder}
 *
 * @beta
 */
var DashboardMetadataObjectBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(DashboardMetadataObjectBuilder, _super);
    function DashboardMetadataObjectBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DashboardMetadataObjectBuilder;
}(factory_1.MetadataObjectBuilder));
exports.DashboardMetadataObjectBuilder = DashboardMetadataObjectBuilder;
/**
 * Dashboard metadata object factory
 *
 * @param ref - dashboard reference
 * @param modifications - dashboard builder modifications to perform
 * @returns created dashboard metadata object
 * @beta
 */
exports.newDashboardMetadataObject = function (ref, modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(DashboardMetadataObjectBuilder, { type: "analyticalDashboard", ref: ref }, modifications);
};
//# sourceMappingURL=dashboardFactory.js.map